import { ReactNode } from 'react'

export default function EmptyState({
  icon, title, children, action
}:{
  icon?: ReactNode; title: string; children?: ReactNode; action?: ReactNode
}){
  return (
    <div className="rounded-2xl border border-dashed border-slate-300 dark:border-slate-700 p-8 text-center bg-white/70 dark:bg-slate-900/60">
      <div className="mx-auto mb-3 h-10 w-10 grid place-items-center rounded-full bg-forest-600/10 text-forest-700">
        {icon}
      </div>
      <div className="font-medium mb-1">{title}</div>
      {children && <div className="text-sm text-slate-600 dark:text-slate-400 mb-4">{children}</div>}
      {action}
    </div>
  )
}
